module.exports = __webpack_public_path__ + "ClinicaPro-Regular-webfont.0ce5d9a545f9b5d5123d.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/assets/fonts/ClinicaPro-Regular-webfont.ttf
// module id = ../../../../../src/assets/fonts/ClinicaPro-Regular-webfont.ttf
// module chunks = styles